export const ARTICLE_STATUSES = {
  DRAFT: "DRAFT",
  LIVE: "LIVE",
  SCHEDULED: "SCHEDULED",
};
